/**
 * PC Pawn Component Factory
 *
 * Creates color-specific PC pawn components using a factory pattern.
 * All 4 color variants are generated from PcPawnComponent with per-color schemes.
 */

import React from 'react';
import type { PawnProps } from '../../constants/types';
import PcPawnComponent from './PcPawnComponent';
import { PC_PAWN_COLOR_SCHEMES, type PcPawnColorScheme } from './constants/pawnColorSchemes';

type PawnColor = 'red' | 'blue' | 'yellow' | 'green';

function createPcPawn(color: PawnColor) {
  const colorScheme: PcPawnColorScheme = PC_PAWN_COLOR_SCHEMES[color];
  const displayName = `Pc${color.charAt(0).toUpperCase() + color.slice(1)}Pawn`;

  const ColoredPawn = React.memo(function ColoredPawn(props: PawnProps) {
    return <PcPawnComponent {...props} colorScheme={colorScheme} />;
  });

  ColoredPawn.displayName = displayName;
  return ColoredPawn;
}

export const RedPawn = createPcPawn('red');
export const BluePawn = createPcPawn('blue');
export const YellowPawn = createPcPawn('yellow');
export const GreenPawn = createPcPawn('green');
